import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-my-requests',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './my-requests.component.html',
  styleUrl: './my-requests.component.scss'
})
export class MyRequestsComponent {
  activeTab = 'Aktiv';
  requests = [
    {
      id: 1,
      name: "Nərimanovda kirayə",
      criteria: "Kirayə, Mənzil, 2 otaq, 500-800 AZN, Nərimanov",
      date: "20.02.2026",
      status: "Active"
    }
  ];
}
